import { Edit, Remove } from "@app/components/Actions";
import pathRoutes from "../../../../routes/pathRoutes";
import { useMasterTables } from "../useMasterTables";
import { PermissionComponentGate } from "@app/utils/PermissionComponentGate";
import { RolesTypes } from "@app/pages/users/utils/helpers";

export const columnsEquipoMide = (keysTables: string[], tableName: string) => [
  {
    field: "id",
    headerName: "id",
    headerAlign: "center",
    align: "left",
    flex: 0,
  },
  {
    field: "equipo",
    headerName: "Equipo",
    headerAlign: "center",
    align: "left",
    flex: 1,
    renderCell: (params: any) => (
      <div>{`${params.row.equipo?.codigo} ${params.row.equipo?.descripcion}`}</div>
    ),
    valueGetter: (params: any) => `${params.row.equipo?.codigo || ""}`,
  },
  {
    field: "preparations",
    headerName: "Tipo de análisis",
    headerAlign: "center",
    align: "left",
    flex: 1,
    renderCell: (params: any) => (
      <div>{`${params.row.tipo_analisis?.codigo} ${params.row.tipo_analisis?.descripcion}`}</div>
    ),
    valueGetter: (params: any) => `${params.row.tipo_analisis?.codigo || ""}`,
  },
  {
    field: "actions",
    headerName: "Acciones",
    headerAlign: "center",
    align: "left",
    flex: 1,
    renderCell: (params: any) => (
      <>
        <PermissionComponentGate
          permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
        >
          <Edit
            to={`${pathRoutes.ADMIN_MASTER_TABLES}/editar/${tableName}/${params.id}`}
          />
          <Remove
            onRemove={() =>
              useMasterTables.getState().deleteData(params.id, tableName)
            }
            title="Va a borrar de forma permanente este registro"
            text="¿Quiere continuar?"
          />
        </PermissionComponentGate>
      </>
    ),
  },
];
